module.exports = __webpack_public_path__ + "static/media/direction (1).fba694ed.svg";